import React from "react";

const ReturnIcon = () => (
  <svg
    className="icon--return"
    xmlns="http://www.w3.org/2000/svg"
    width="77.568"
    height="77.568"
    viewBox="0 0 77.568 77.568"
  >
    <path
      fill="none"
      stroke="#fff"
      strokeWidth="4"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M52.137 35.557H36.485l4.305-4.305c1.528-1.526 1.528-4.003 0-5.53-1.528-1.528-4.003-1.528-5.532 0l-8.21 8.21-.004-.005v.01l-5.525 5.525 5.52 5.525V45l.01-.007.217.218 7.99 7.995c1.53 1.526 4.005 1.526 5.533 0 1.528-1.528 1.528-4.005 0-5.53l-4.295-4.297h15.642c2.16 0 3.91-1.75 3.912-3.91-.003-2.16-1.752-3.91-3.913-3.91z"
    />
    <circle
      fill="none"
      stroke="#fff"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      cx="38.784"
      cy="38.784"
      r="36.784"
    />
  </svg>
);

export default ReturnIcon;
